<template>
  <div class="square__shrinks">
    <div style="padding: 5px; border-bottom: 1px solid #e6e6e6; margin-bottom: 10px;">
      <h5 class="f-title-7" style="color: #646464">
        {{ title }}
      </h5>
    </div>
    <div style="display: flex">
      <div
        class="square__divider"
        v-for="item in data"
        :key="item.title"
        v-bind="item"
      >
        <SquareShrink v-bind="item" :max="max" />
      </div>
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        margin-top: 10px;
        transition: all 0.35s ease-out;
      "
      :style="{ opacity: showLabel ? 1 : 0 }"
    >
      <span
        class="f-ui-1-bold"
        style="
          color: #fff;
          background: #92d050;
          padding: 5px 10px;
          border-radius: 5px;
        "
        >Universal access in NZE 2030</span
      >
    </div>
  </div>
</template>

<script>
import SquareShrink from "./SquareShrink.vue";
export default {
  components: {
    SquareShrink,
  },
  data() {
    return {
      showLabel: false,
    };
  },
  props: {
    data: {
      type: Array,
    },
    title: {
      type: String,
      default: "",
    },
    max: {
      type: Number,
    },
  },
  mounted() {
    setTimeout(() => (this.showLabel = true), 2200);
  },
};
</script>

<style scoped>
.square__shrinks {
  display: flex;
  flex-flow: column;
  width: 100%;
}
.square__divider {
  width: 100%;
}
</style>
